import React from "react";
import styled from "styled-components";
import CallWindowIcon from "./CallWindowIcon";

function AddCardRow({ date, onAddActivity }) {
    return (
        <AddCardWrapper>
            <CallWindowIcon
                icon="/images/add.svg"
                date={date}
                onAddActivity={onAddActivity}
                isEditMode={false}
            />
            <Format>Add a Card</Format>
        </AddCardWrapper>
    );
}

const Format = styled.div`
    color: #969a97;
    font-weight: 600;
    font-family: Inter, sans-serif;
    margin-top: 2px;
    cursor: default;
`
const AddCardWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

export default AddCardRow;